/*bundling*/
/*setting-up-a-build-script*/
/*building-our-package-before-our-app*/
/*setting-up-a-dev-script*/
/*versioning-and-publishing*/
/*publishing*/
/*using-changesets-with-turborepo*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "发布库",
  "description": "学习如何从 monorepo 将库发布到 npm 仓库。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "使用合适的工具，从 monorepo 将包发布到 npm 仓库可以非常流畅。"
  }, {
    "heading": "",
    "content": "¥Publishing a package to the npm registry from a monorepo can be a smooth experience, with the right tools."
  }, {
    "heading": "",
    "content": "虽然本指南无法解决构建健壮软件包所需的所有编译、打包和发布配置问题，但它将解释一些基础知识。"
  }, {
    "heading": "",
    "content": "¥While this guide cannot solve for every possible compiling, bundling, and publishing configuration needed for robust packages, it will explain some of the basics."
  }, {
    "heading": "",
    "content": "如果你想将部分 monorepo 软件包发布到 npm，则应遵循此设置。如果你不需要发布到 npm，则应该使用 内部包。它们的设置和使用更加简单。"
  }, {
    "heading": "",
    "content": "¥You should follow this setup if you want to publish some of your monorepo's\npackages to npm. If you don't need to publish to npm, you should use an\nInternal\nPackage instead.\nThey're much easier to set up and use."
  }, {
    "heading": "打包-bundling",
    "content": "¥Bundling"
  }, {
    "heading": "打包-bundling",
    "content": "与 内部软件包 不同，外部包可以部署到 npm 并在本地使用。在本指南中，我们将把一个包打包到 ECMAScript 模块 (esm) 和 CommonJS 模块 (cjs)，这是 npm 上最常用的格式。"
  }, {
    "heading": "打包-bundling",
    "content": "¥Unlike Internal Packages, external packages can be deployed to npm and used locally. In this guide, we'll bundle a package to both ECMAScript modules (esm) and CommonJS modules (cjs), the most commonly used formats on npm."
  }, {
    "heading": "设置构建脚本-setting-up-a-build-script",
    "content": "¥Setting up a build script"
  }, {
    "heading": "设置构建脚本-setting-up-a-build-script",
    "content": "让我们从使用 内部软件包 教程创建的包开始。"
  }, {
    "heading": "设置构建脚本-setting-up-a-build-script",
    "content": "¥Let's start with a package created using the Internal Packages tutorial."
  }, {
    "heading": "设置构建脚本-setting-up-a-build-script",
    "content": "在那里，我们创建了一个 @repo/math 包，其中包含一些用于加减数字的辅助函数。我们认为这个包对于 npm 来说已经足够好了，所以我们要把它打包起来。"
  }, {
    "heading": "设置构建脚本-setting-up-a-build-script",
    "content": "¥There, we created a @repo/math package which contained a few helper functions for adding and subtracting numbers. We've decided that this package is good enough for npm, so we're going to bundle it."
  }, {
    "heading": "设置构建脚本-setting-up-a-build-script",
    "content": "我们将使用打包器将 build 脚本添加到 @repo/math。如果你不确定选择哪一个，我们推荐 tsup。"
  }, {
    "heading": "设置构建脚本-setting-up-a-build-script",
    "content": "¥We're going to add a build script to @repo/math, using a bundler. If you're unsure which one to choose, we recommend tsup."
  }, {
    "heading": "设置构建脚本-setting-up-a-build-script",
    "content": "使用包管理器将 tsup 安装到 ./packages/math 包中，然后为其创建构建脚本："
  }, {
    "heading": "设置构建脚本-setting-up-a-build-script",
    "content": "¥Install tsup inside the ./packages/math package using your package manager and then create a build script for it:"
  }, {
    "heading": "设置构建脚本-setting-up-a-build-script",
    "content": "tsup 默认将文件输出到 dist 目录，因此你应该："
  }, {
    "heading": "设置构建脚本-setting-up-a-build-script",
    "content": "¥tsup outputs files to the dist directory by default, so you should:"
  }, {
    "heading": "设置构建脚本-setting-up-a-build-script",
    "content": "将 dist 添加到你的 .gitignore 文件中，以确保它们未提交到源代码管理中。"
  }, {
    "heading": "设置构建脚本-setting-up-a-build-script",
    "content": "¥Add dist to your .gitignore files to make sure they aren't committed to source control."
  }, {
    "heading": "设置构建脚本-setting-up-a-build-script",
    "content": "将 dist 添加到 turbo.json 中 build 的输出部分。"
  }, {
    "heading": "设置构建脚本-setting-up-a-build-script",
    "content": "¥Add dist to the outputs of build in your turbo.json."
  }, {
    "heading": "设置构建脚本-setting-up-a-build-script",
    "content": "这样，当 tsup 运行时，Turborepo 的输出就可以是 cached。"
  }, {
    "heading": "设置构建脚本-setting-up-a-build-script",
    "content": "¥That way, when tsup is run the outputs can be cached by Turborepo."
  }, {
    "heading": "设置构建脚本-setting-up-a-build-script",
    "content": "最后，我们应该更新包的入口点。在 package.json 文件中，将 main 更改为指向使用 CommonJS 模块的客户端的 ./dist/index.js（cjs），将 module 更改为指向使用 ECMAScript 模块的客户端的 ./dist/index.mjs（esm），并将 types 更改为指向类型定义文件。 - ./dist/index.d.ts："
  }, {
    "heading": "设置构建脚本-setting-up-a-build-script",
    "content": "¥Finally, we should update our package entrypoints. Inside package.json, change main to point at ./dist/index.js for clients using CommonJS modules (cjs), module to point at ./dist/index.mjs for clients using ECMAScript modules (esm), and types to the type definition file - ./dist/index.d.ts:"
  }, {
    "heading": "设置构建脚本-setting-up-a-build-script",
    "content": "无需同时打包到 cjs 和 esm。但是，我们建议这样做，因为它可以让你的包在更广泛的环境中使用。"
  }, {
    "heading": "设置构建脚本-setting-up-a-build-script",
    "content": "¥It is not required to bundle to both cjs and esm. However, it is recommended, as it allows your package to be used in a wider variety of environments."
  }, {
    "heading": "设置构建脚本-setting-up-a-build-script",
    "content": "如果你在使用 main、module 和 types 时遇到错误，请查看 tsup 文档。"
  }, {
    "heading": "设置构建脚本-setting-up-a-build-script",
    "content": "¥If you run into errors by using main, module and types, take a look at the tsup docs."
  }, {
    "heading": "设置构建脚本-setting-up-a-build-script",
    "content": "打包是一个复杂的话题，我们这里篇幅有限，无法一一详述！"
  }, {
    "heading": "设置构建脚本-setting-up-a-build-script",
    "content": "¥Bundling is a complicated topic, and we don't have space here to cover everything!"
  }, {
    "heading": "在构建之前构建软件包应用-building-our-package-before-our-app",
    "content": "¥Building our package before our app"
  }, {
    "heading": "在构建之前构建软件包应用-building-our-package-before-our-app",
    "content": "在运行 turbo run build 之前，我们需要考虑一件事。我们刚刚在 monorepo 中添加了一个 任务依赖 任务。packages/math 的 build 需要在 apps/web 的 build 之前运行。"
  }, {
    "heading": "在构建之前构建软件包应用-building-our-package-before-our-app",
    "content": "¥Before we can run turbo run build, there's one thing we need to consider. We've just added a task dependency into our monorepo. The build of packages/math needs to run before the build of apps/web."
  }, {
    "heading": "在构建之前构建软件包应用-building-our-package-before-our-app",
    "content": "幸运的是，我们可以使用 dependsOn 轻松配置这一点。"
  }, {
    "heading": "在构建之前构建软件包应用-building-our-package-before-our-app",
    "content": "¥Fortunately, we can use dependsOn to easily configure this."
  }, {
    "heading": "在构建之前构建软件包应用-building-our-package-before-our-app",
    "content": "现在，我们可以运行 turbo run build，它会在构建我们的应用之前自动构建我们的包。"
  }, {
    "heading": "在构建之前构建软件包应用-building-our-package-before-our-app",
    "content": "¥Now, we can run turbo run build, and it'll automatically build our packages before it builds our app."
  }, {
    "heading": "设置开发脚本-setting-up-a-dev-script",
    "content": "¥Setting up a dev script"
  }, {
    "heading": "设置开发脚本-setting-up-a-dev-script",
    "content": "我们的设置存在一个小问题。我们的软件包构建得很好，但在开发环境中运行不佳。我们对 @repo/math 包所做的更改未反映在我们的应用中。"
  }, {
    "heading": "设置开发脚本-setting-up-a-dev-script",
    "content": "¥There's a small issue with our setup. We are building our package just fine, but it's not working great in dev. Changes that we make to our @repo/math package aren't being reflected in our app."
  }, {
    "heading": "设置开发脚本-setting-up-a-dev-script",
    "content": "这是因为我们没有 dev 脚本来在工作时重建包。我们可以轻松添加一个："
  }, {
    "heading": "设置开发脚本-setting-up-a-dev-script",
    "content": "¥That's because we don't have a dev script to rebuild our packages while we're working. We can add one easily:"
  }, {
    "heading": "设置开发脚本-setting-up-a-dev-script",
    "content": "这会将 --watch 标志传递给 tsup，这意味着它将监视文件更改。"
  }, {
    "heading": "设置开发脚本-setting-up-a-dev-script",
    "content": "¥This passes the --watch flag to tsup, meaning it will watch for file changes."
  }, {
    "heading": "设置开发脚本-setting-up-a-dev-script",
    "content": "如果我们已经在 turbo.json 中设置了 开发脚本，则运行 turbo run dev 将同时运行 packages/math 开发任务和 apps/web 开发任务。"
  }, {
    "heading": "设置开发脚本-setting-up-a-dev-script",
    "content": "¥If we've already set up dev scripts in our turbo.json, running turbo run dev will run our packages/math dev task in parallel with our apps/web dev task."
  }, {
    "heading": "设置开发脚本-setting-up-a-dev-script",
    "content": "我们的包现在可以考虑部署到 npm 了。在我们的 版本控制和发布 部分，我们将执行此操作。"
  }, {
    "heading": "设置开发脚本-setting-up-a-dev-script",
    "content": "¥Our package is now in a spot where we can consider deploying to npm. In our versioning and publishing section, we'll do just that."
  }, {
    "heading": "版本控制和发布-versioning-and-publishing",
    "content": "¥Versioning and publishing"
  }, {
    "heading": "版本控制和发布-versioning-and-publishing",
    "content": "在 monorepo 中手动版本控制和发布包可能很繁琐。幸运的是，有一个工具可以让事情变得简单。 - 变更集 CLI。"
  }, {
    "heading": "版本控制和发布-versioning-and-publishing",
    "content": "¥Manually versioning and publishing packages in a monorepo can be tiresome. Luckily, there's a tool that makes things easy - the Changesets CLI."
  }, {
    "heading": "版本控制和发布-versioning-and-publishing",
    "content": "我们推荐使用变更集，因为它使用起来直观易用，并且 - 就像 Turborepo 一样 - 适用于你已习惯的 monorepo 工具。"
  }, {
    "heading": "版本控制和发布-versioning-and-publishing",
    "content": "¥We recommend Changesets because it's intuitive to use, and - just like Turborepo - fits with the monorepo tools you're already used to."
  }, {
    "heading": "版本控制和发布-versioning-and-publishing",
    "content": "一些替代方案如下："
  }, {
    "heading": "版本控制和发布-versioning-and-publishing",
    "content": "¥Some alternatives are:"
  }, {
    "heading": "版本控制和发布-versioning-and-publishing",
    "content": "intuit/auto - 根据拉取请求中的语义版本标签生成版本"
  }, {
    "heading": "版本控制和发布-versioning-and-publishing",
    "content": "¥intuit/auto - Generate releases based on semantic version labels on pull requests"
  }, {
    "heading": "版本控制和发布-versioning-and-publishing",
    "content": "microsoft/beachball - 最阳光的语义版本缓冲器"
  }, {
    "heading": "版本控制和发布-versioning-and-publishing",
    "content": "¥microsoft/beachball - The Sunniest Semantic Version Bumper"
  }, {
    "heading": "发布-publishing",
    "content": "¥Publishing"
  }, {
    "heading": "发布-publishing",
    "content": "软件包打包后，你可以将其发布到 npm 仓库。"
  }, {
    "heading": "发布-publishing",
    "content": "¥Once your package has been bundled, you can then publish it to the npm registry."
  }, {
    "heading": "发布-publishing",
    "content": "我们建议你查看变更集文档。以下是我们推荐的阅读顺序："
  }, {
    "heading": "发布-publishing",
    "content": "¥We recommend taking a look at the Changesets docs. Here's our recommended reading order:"
  }, {
    "heading": "发布-publishing",
    "content": "为什么使用变更集？ - 一个介绍基础知识的简介。"
  }, {
    "heading": "发布-publishing",
    "content": "¥Why use changesets? - an intro that takes you through the fundamentals."
  }, {
    "heading": "发布-publishing",
    "content": "安装说明"
  }, {
    "heading": "发布-publishing",
    "content": "¥Installation instructions"
  }, {
    "heading": "发布-publishing",
    "content": "如果你使用的是 GitHub，请考虑使用 变更集 GitHub 机器人 - 一个机器人，它会提醒你将变更集添加到 PR。"
  }, {
    "heading": "发布-publishing",
    "content": "¥If you're using GitHub, consider using the Changeset GitHub bot - a bot to nudge you to add changesets to PR's."
  }, {
    "heading": "发布-publishing",
    "content": "你还应该考虑添加 变更集 GitHub 操作。 - 一个使发布变得极其简单的工具。"
  }, {
    "heading": "发布-publishing",
    "content": "¥You should also consider adding the Changesets GitHub action - a tool which makes publishing extremely easy."
  }, {
    "heading": "将变更集与-turborepo-结合使用-using-changesets-with-turborepo",
    "content": "¥Using Changesets with Turborepo"
  }, {
    "heading": "将变更集与-turborepo-结合使用-using-changesets-with-turborepo",
    "content": "开始使用变更集后，你将可以使用三个有用的命令："
  }, {
    "heading": "将变更集与-turborepo-结合使用-using-changesets-with-turborepo",
    "content": "¥Once you've started using Changesets, you'll gain access to three useful commands:"
  }, {
    "heading": "将变更集与-turborepo-结合使用-using-changesets-with-turborepo",
    "content": "将你的发布流程链接到 Turborepo 可以使你的部署组织更加简单快捷。"
  }, {
    "heading": "将变更集与-turborepo-结合使用-using-changesets-with-turborepo",
    "content": "¥Linking your publishing flow into Turborepo can make organizing your deploy a lot simpler and faster."
  }, {
    "heading": "将变更集与-turborepo-结合使用-using-changesets-with-turborepo",
    "content": "我们建议将变更集配置为自动提交 changeset version 的变更。"
  }, {
    "heading": "将变更集与-turborepo-结合使用-using-changesets-with-turborepo",
    "content": "¥Our recommendation is to configure Changesets to automatically commit changeset version's changes"
  }, {
    "heading": "将变更集与-turborepo-结合使用-using-changesets-with-turborepo",
    "content": "并将 publish-packages 脚本添加到你的根 package.json 中："
  }, {
    "heading": "将变更集与-turborepo-结合使用-using-changesets-with-turborepo",
    "content": "¥and add a publish-packages script into your root package.json:"
  }, {
    "heading": "将变更集与-turborepo-结合使用-using-changesets-with-turborepo",
    "content": "如果你的包是公共的，请将变更集的 access 设置为 public："
  }, {
    "heading": "将变更集与-turborepo-结合使用-using-changesets-with-turborepo",
    "content": "¥If your packages are public, set Changeset's access to public:"
  }, {
    "heading": "将变更集与-turborepo-结合使用-using-changesets-with-turborepo",
    "content": "我们推荐使用 publish-packages，这样它就不会与 npm 内置的 publish 脚本冲突。"
  }, {
    "heading": "将变更集与-turborepo-结合使用-using-changesets-with-turborepo",
    "content": "¥We recommend publish-packages so that it doesn't conflict with npm's\nbuilt-in publish script."
  }, {
    "heading": "将变更集与-turborepo-结合使用-using-changesets-with-turborepo",
    "content": "这意味着当你运行 publish-packages 时，你的 monorepo 会被构建、linted、测试和发布。 - 你将受益于 Turborepo 的所有加速功能。"
  }, {
    "heading": "将变更集与-turborepo-结合使用-using-changesets-with-turborepo",
    "content": "¥This means that when you run publish-packages, your monorepo gets built, linted, tested and published - and you benefit from all of Turborepo's speedups."
  }],
  "headings": [{
    "id": "打包-bundling",
    "content": "打包 /*bundling*/"
  }, {
    "id": "设置构建脚本-setting-up-a-build-script",
    "content": "设置构建脚本 /*setting-up-a-build-script*/"
  }, {
    "id": "在构建之前构建软件包应用-building-our-package-before-our-app",
    "content": "在构建之前构建软件包应用 /*building-our-package-before-our-app*/"
  }, {
    "id": "设置开发脚本-setting-up-a-dev-script",
    "content": "设置开发脚本 /*setting-up-a-dev-script*/"
  }, {
    "id": "版本控制和发布-versioning-and-publishing",
    "content": "版本控制和发布 /*versioning-and-publishing*/"
  }, {
    "id": "发布-publishing",
    "content": "发布 /*publishing*/"
  }, {
    "id": "将变更集与-turborepo-结合使用-using-changesets-with-turborepo",
    "content": "将变更集与 Turborepo 结合使用 /*using-changesets-with-turborepo*/"
  }]
};
import {Callout} from '#components/callout';
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
export const toc = [{
  depth: 2,
  url: "#打包-bundling",
  title: _jsx(_Fragment, {
    children: "打包 "
  })
}, {
  depth: 2,
  url: "#设置构建脚本-setting-up-a-build-script",
  title: _jsx(_Fragment, {
    children: "设置构建脚本 "
  })
}, {
  depth: 3,
  url: "#在构建之前构建软件包应用-building-our-package-before-our-app",
  title: _jsx(_Fragment, {
    children: "在构建之前构建软件包应用 "
  })
}, {
  depth: 3,
  url: "#设置开发脚本-setting-up-a-dev-script",
  title: _jsx(_Fragment, {
    children: "设置开发脚本 "
  })
}, {
  depth: 2,
  url: "#版本控制和发布-versioning-and-publishing",
  title: _jsx(_Fragment, {
    children: "版本控制和发布 "
  })
}, {
  depth: 2,
  url: "#发布-publishing",
  title: _jsx(_Fragment, {
    children: "发布 "
  })
}, {
  depth: 2,
  url: "#将变更集与-turborepo-结合使用-using-changesets-with-turborepo",
  title: _jsx(_Fragment, {
    children: "将变更集与 Turborepo 结合使用 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    li: "li",
    ol: "ol",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "使用合适的工具，从 monorepo 将包发布到 npm 仓库可以非常流畅。"
    }), "\n", _jsx(_components.p, {
      children: "¥Publishing a package to the npm registry from a monorepo can be a smooth experience, with the right tools."
    }), "\n", _jsx(_components.p, {
      children: "虽然本指南无法解决构建健壮软件包所需的所有编译、打包和发布配置问题，但它将解释一些基础知识。"
    }), "\n", _jsx(_components.p, {
      children: "¥While this guide cannot solve for every possible compiling, bundling, and publishing configuration needed for robust packages, it will explain some of the basics."
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsxs(_components.p, {
        children: ["如果你想将部分 monorepo 软件包发布到 npm，则应遵循此设置。如果你不需要发布到 npm，则应该使用 ", _jsx(_components.a, {
          href: "/docs/crafting-your-repository/creating-an-internal-package",
          children: "内部包"
        }), "。它们的设置和使用更加简单。"]
      }), _jsxs(_components.p, {
        children: ["¥You should follow this setup if you want to publish some of your monorepo's\npackages to npm. If you don't need to publish to npm, you should use an\n", _jsx(_components.a, {
          href: "/docs/crafting-your-repository/creating-an-internal-package",
          children: "Internal\nPackage"
        }), " instead.\nThey're much easier to set up and use."]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "打包-bundling",
      children: "打包 "
    }), "\n", _jsx(_components.p, {
      children: "¥Bundling"
    }), "\n", _jsxs(_components.p, {
      children: ["与 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/creating-an-internal-package",
        children: "内部软件包"
      }), " 不同，外部包可以部署到 ", _jsx(_components.a, {
        href: "https://www.npmjs.com",
        children: "npm"
      }), " 并在本地使用。在本指南中，我们将把一个包打包到 ", _jsx(_components.a, {
        href: "https://web.nodejs.cn/en-US/docs/Web/JavaScript/Guide/Modules",
        children: "ECMAScript 模块"
      }), " (", _jsx(_components.code, {
        children: "esm"
      }), ") 和 ", _jsx(_components.a, {
        href: "https://en.wikipedia.org/wiki/CommonJS",
        children: "CommonJS 模块"
      }), " (", _jsx(_components.code, {
        children: "cjs"
      }), ")，这是 npm 上最常用的格式。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Unlike ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/creating-an-internal-package",
        children: "Internal Packages"
      }), ", external packages can be deployed to ", _jsx(_components.a, {
        href: "https://www.npmjs.com",
        children: "npm"
      }), " ", _jsx(_components.em, {
        children: "and"
      }), " used locally. In this guide, we'll bundle a package to both ", _jsx(_components.a, {
        href: "https://web.nodejs.cn/en-US/docs/Web/JavaScript/Guide/Modules",
        children: "ECMAScript modules"
      }), " (", _jsx(_components.code, {
        children: "esm"
      }), ") and ", _jsx(_components.a, {
        href: "https://en.wikipedia.org/wiki/CommonJS",
        children: "CommonJS modules"
      }), " (", _jsx(_components.code, {
        children: "cjs"
      }), "), the most commonly used formats on npm."]
    }), "\n", _jsx(_components.h2, {
      id: "设置构建脚本-setting-up-a-build-script",
      children: "设置构建脚本 "
    }), "\n", _jsx(_components.p, {
      children: "¥Setting up a build script"
    }), "\n", _jsxs(_components.p, {
      children: ["让我们从使用 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/creating-an-internal-package",
        children: "内部软件包"
      }), " 教程创建的包开始。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Let's start with a package created using the ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/creating-an-internal-package",
        children: "Internal Packages"
      }), " tutorial."]
    }), "\n", _jsxs(_components.p, {
      children: ["在那里，我们创建了一个 ", _jsx(_components.code, {
        children: "@repo/math"
      }), " 包，其中包含一些用于加减数字的辅助函数。我们认为这个包对于 npm 来说已经足够好了，所以我们要把它打包起来。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥There, we created a ", _jsx(_components.code, {
        children: "@repo/math"
      }), " package which contained a few helper functions for adding and subtracting numbers. We've decided that this package is good enough for npm, so we're going to bundle it."]
    }), "\n", _jsxs(_components.p, {
      children: ["我们将使用打包器将 ", _jsx(_components.code, {
        children: "build"
      }), " 脚本添加到 ", _jsx(_components.code, {
        children: "@repo/math"
      }), "。如果你不确定选择哪一个，我们推荐 ", _jsx(_components.a, {
        href: "https://tsup.egoist.dev/",
        children: _jsx(_components.code, {
          children: "tsup"
        })
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥We're going to add a ", _jsx(_components.code, {
        children: "build"
      }), " script to ", _jsx(_components.code, {
        children: "@repo/math"
      }), ", using a bundler. If you're unsure which one to choose, we recommend ", _jsx(_components.a, {
        href: "https://tsup.egoist.dev/",
        children: _jsx(_components.code, {
          children: "tsup"
        })
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["使用包管理器将 ", _jsx(_components.code, {
        children: "tsup"
      }), " 安装到 ", _jsx(_components.code, {
        children: "./packages/math"
      }), " 包中，然后为其创建构建脚本："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Install ", _jsx(_components.code, {
        children: "tsup"
      }), " inside the ", _jsx(_components.code, {
        children: "./packages/math"
      }), " package using your package manager and then create a build script for it:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./packages/math/package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"tsup src/index.ts --format cjs,esm --dts\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "tsup"
      }), " 默认将文件输出到 ", _jsx(_components.code, {
        children: "dist"
      }), " 目录，因此你应该："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "tsup"
      }), " outputs files to the ", _jsx(_components.code, {
        children: "dist"
      }), " directory by default, so you should:"]
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["将 ", _jsx(_components.code, {
            children: "dist"
          }), " 添加到你的 ", _jsx(_components.code, {
            children: ".gitignore"
          }), " 文件中，以确保它们未提交到源代码管理中。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Add ", _jsx(_components.code, {
            children: "dist"
          }), " to your ", _jsx(_components.code, {
            children: ".gitignore"
          }), " files to make sure they aren't committed to source control."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["将 ", _jsx(_components.code, {
            children: "dist"
          }), " 添加到 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 中 ", _jsx(_components.code, {
            children: "build"
          }), " 的输出部分。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Add ", _jsx(_components.code, {
            children: "dist"
          }), " to the outputs of ", _jsx(_components.code, {
            children: "build"
          }), " in your ", _jsx(_components.code, {
            children: "turbo.json"
          }), "."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"dist/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["这样，当 ", _jsx(_components.code, {
        children: "tsup"
      }), " 运行时，Turborepo 的输出就可以是 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/caching",
        children: "cached"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥That way, when ", _jsx(_components.code, {
        children: "tsup"
      }), " is run the outputs can be ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/caching",
        children: "cached"
      }), " by Turborepo."]
    }), "\n", _jsxs(_components.p, {
      children: ["最后，我们应该更新包的入口点。在 ", _jsx(_components.code, {
        children: "package.json"
      }), " 文件中，将 ", _jsx(_components.code, {
        children: "main"
      }), " 更改为指向使用 CommonJS 模块的客户端的 ", _jsx(_components.code, {
        children: "./dist/index.js"
      }), "（", _jsx(_components.code, {
        children: "cjs"
      }), "），将 ", _jsx(_components.code, {
        children: "module"
      }), " 更改为指向使用 ECMAScript 模块的客户端的 ", _jsx(_components.code, {
        children: "./dist/index.mjs"
      }), "（", _jsx(_components.code, {
        children: "esm"
      }), "），并将 ", _jsx(_components.code, {
        children: "types"
      }), " 更改为指向类型定义文件。 - ", _jsx(_components.code, {
        children: "./dist/index.d.ts"
      }), "："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Finally, we should update our package entrypoints. Inside ", _jsx(_components.code, {
        children: "package.json"
      }), ", change ", _jsx(_components.code, {
        children: "main"
      }), " to point at ", _jsx(_components.code, {
        children: "./dist/index.js"
      }), " for clients using CommonJS modules (", _jsx(_components.code, {
        children: "cjs"
      }), "), ", _jsx(_components.code, {
        children: "module"
      }), " to point at ", _jsx(_components.code, {
        children: "./dist/index.mjs"
      }), " for clients using ECMAScript modules (", _jsx(_components.code, {
        children: "esm"
      }), "), and ", _jsx(_components.code, {
        children: "types"
      }), " to the type definition file - ", _jsx(_components.code, {
        children: "./dist/index.d.ts"
      }), ":"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./packages/math/package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"main\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./dist/index.js\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"module\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./dist/index.mjs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"types\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./dist/index.d.ts\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(Callout, {
      children: [_jsxs(_components.p, {
        children: ["无需同时打包到 ", _jsx(_components.code, {
          children: "cjs"
        }), " 和 ", _jsx(_components.code, {
          children: "esm"
        }), "。但是，我们建议这样做，因为它可以让你的包在更广泛的环境中使用。"]
      }), _jsxs(_components.p, {
        children: ["¥It is not required to bundle to both ", _jsx(_components.code, {
          children: "cjs"
        }), " and ", _jsx(_components.code, {
          children: "esm"
        }), ". However, it is recommended, as it allows your package to be used in a wider variety of environments."]
      }), _jsxs(_components.p, {
        children: ["如果你在使用 ", _jsx(_components.code, {
          children: "main"
        }), "、", _jsx(_components.code, {
          children: "module"
        }), " 和 ", _jsx(_components.code, {
          children: "types"
        }), " 时遇到错误，请查看 ", _jsx(_components.a, {
          href: "https://tsup.egoist.dev/#bundle-formats",
          children: "tsup 文档"
        }), "。"]
      }), _jsxs(_components.p, {
        children: ["¥If you run into errors by using ", _jsx(_components.code, {
          children: "main"
        }), ", ", _jsx(_components.code, {
          children: "module"
        }), " and ", _jsx(_components.code, {
          children: "types"
        }), ", take a look at the ", _jsx(_components.a, {
          href: "https://tsup.egoist.dev/#bundle-formats",
          children: "tsup docs"
        }), "."]
      }), _jsx(_components.p, {
        children: "打包是一个复杂的话题，我们这里篇幅有限，无法一一详述！"
      }), _jsx(_components.p, {
        children: "¥Bundling is a complicated topic, and we don't have space here to cover everything!"
      })]
    }), "\n", _jsx(_components.h3, {
      id: "在构建之前构建软件包应用-building-our-package-before-our-app",
      children: "在构建之前构建软件包应用 "
    }), "\n", _jsx(_components.p, {
      children: "¥Building our package before our app"
    }), "\n", _jsxs(_components.p, {
      children: ["在运行 ", _jsx(_components.code, {
        children: "turbo run build"
      }), " 之前，我们需要考虑一件事。我们刚刚在 monorepo 中添加了一个 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/running-tasks",
        children: "任务依赖"
      }), " 任务。", _jsx(_components.code, {
        children: "packages/math"
      }), " 的 ", _jsx(_components.code, {
        children: "build"
      }), " 需要在 ", _jsx(_components.code, {
        children: "apps/web"
      }), " 的 ", _jsx(_components.code, {
        children: "build"
      }), " 之前运行。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Before we can run ", _jsx(_components.code, {
        children: "turbo run build"
      }), ", there's one thing we need to consider. We've just added a ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/running-tasks",
        children: "task dependency"
      }), " into our monorepo. The ", _jsx(_components.code, {
        children: "build"
      }), " of ", _jsx(_components.code, {
        children: "packages/math"
      }), " needs to run ", _jsx(_components.strong, {
        children: "before"
      }), " the ", _jsx(_components.code, {
        children: "build"
      }), " of ", _jsx(_components.code, {
        children: "apps/web"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["幸运的是，我们可以使用 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#dependson",
        children: _jsx(_components.code, {
          children: "dependsOn"
        })
      }), " 轻松配置这一点。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Fortunately, we can use ", _jsx(_components.a, {
        href: "/docs/reference/configuration#dependson",
        children: _jsx(_components.code, {
          children: "dependsOn"
        })
      }), " to easily configure this."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["现在，我们可以运行 ", _jsx(_components.code, {
        children: "turbo run build"
      }), "，它会在构建我们的应用之前自动构建我们的包。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Now, we can run ", _jsx(_components.code, {
        children: "turbo run build"
      }), ", and it'll automatically build our packages ", _jsx(_components.em, {
        children: "before"
      }), " it builds our app."]
    }), "\n", _jsx(_components.h3, {
      id: "设置开发脚本-setting-up-a-dev-script",
      children: "设置开发脚本 "
    }), "\n", _jsx(_components.p, {
      children: "¥Setting up a dev script"
    }), "\n", _jsxs(_components.p, {
      children: ["我们的设置存在一个小问题。我们的软件包构建得很好，但在开发环境中运行不佳。我们对 ", _jsx(_components.code, {
        children: "@repo/math"
      }), " 包所做的更改未反映在我们的应用中。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥There's a small issue with our setup. We are building our package just fine, but it's not working great in dev. Changes that we make to our ", _jsx(_components.code, {
        children: "@repo/math"
      }), " package aren't being reflected in our app."]
    }), "\n", _jsxs(_components.p, {
      children: ["这是因为我们没有 ", _jsx(_components.code, {
        children: "dev"
      }), " 脚本来在工作时重建包。我们可以轻松添加一个："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥That's because we don't have a ", _jsx(_components.code, {
        children: "dev"
      }), " script to rebuild our packages while we're working. We can add one easily:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./packages/math/package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"tsup src/index.ts --format cjs,esm --dts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"tsup src/index.ts --format cjs,esm --dts "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              className: "highlighted-word",
              children: "--watch"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["这会将 ", _jsx(_components.code, {
        children: "--watch"
      }), " 标志传递给 ", _jsx(_components.code, {
        children: "tsup"
      }), "，这意味着它将监视文件更改。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This passes the ", _jsx(_components.code, {
        children: "--watch"
      }), " flag to ", _jsx(_components.code, {
        children: "tsup"
      }), ", meaning it will watch for file changes."]
    }), "\n", _jsxs(_components.p, {
      children: ["如果我们已经在 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 中设置了 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/developing-applications#configuring-development-tasks",
        children: "开发脚本"
      }), "，则运行 ", _jsx(_components.code, {
        children: "turbo run dev"
      }), " 将同时运行 ", _jsx(_components.code, {
        children: "packages/math"
      }), " 开发任务和 ", _jsx(_components.code, {
        children: "apps/web"
      }), " 开发任务。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If we've already set up ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/developing-applications#configuring-development-tasks",
        children: "dev scripts"
      }), " in our ", _jsx(_components.code, {
        children: "turbo.json"
      }), ", running ", _jsx(_components.code, {
        children: "turbo run dev"
      }), " will run our ", _jsx(_components.code, {
        children: "packages/math"
      }), " dev task in parallel with our ", _jsx(_components.code, {
        children: "apps/web"
      }), " dev task."]
    }), "\n", _jsxs(_components.p, {
      children: ["我们的包现在可以考虑部署到 npm 了。在我们的 ", _jsx(_components.a, {
        href: "#versioning-and-publishing",
        children: "版本控制和发布"
      }), " 部分，我们将执行此操作。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Our package is now in a spot where we can consider deploying to npm. In our ", _jsx(_components.a, {
        href: "#versioning-and-publishing",
        children: "versioning and publishing"
      }), " section, we'll do just that."]
    }), "\n", _jsx(_components.h2, {
      id: "版本控制和发布-versioning-and-publishing",
      children: "版本控制和发布 "
    }), "\n", _jsx(_components.p, {
      children: "¥Versioning and publishing"
    }), "\n", _jsxs(_components.p, {
      children: ["在 monorepo 中手动版本控制和发布包可能很繁琐。幸运的是，有一个工具可以让事情变得简单。 - ", _jsx(_components.a, {
        href: "https://github.com/changesets/changesets",
        children: "变更集"
      }), " CLI。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Manually versioning and publishing packages in a monorepo can be tiresome. Luckily, there's a tool that makes things easy - the ", _jsx(_components.a, {
        href: "https://github.com/changesets/changesets",
        children: "Changesets"
      }), " CLI."]
    }), "\n", _jsx(_components.p, {
      children: "我们推荐使用变更集，因为它使用起来直观易用，并且 - 就像 Turborepo 一样 - 适用于你已习惯的 monorepo 工具。"
    }), "\n", _jsx(_components.p, {
      children: "¥We recommend Changesets because it's intuitive to use, and - just like Turborepo - fits with the monorepo tools you're already used to."
    }), "\n", _jsx(_components.p, {
      children: "一些替代方案如下："
    }), "\n", _jsx(_components.p, {
      children: "¥Some alternatives are:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "https://github.com/intuit/auto",
            children: "intuit/auto"
          }), " - 根据拉取请求中的语义版本标签生成版本"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "https://github.com/intuit/auto",
            children: "intuit/auto"
          }), " - Generate releases based on semantic version labels on pull requests"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "https://github.com/microsoft/beachball",
            children: "microsoft/beachball"
          }), " - 最阳光的语义版本缓冲器"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "https://github.com/microsoft/beachball",
            children: "microsoft/beachball"
          }), " - The Sunniest Semantic Version Bumper"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "发布-publishing",
      children: "发布 "
    }), "\n", _jsx(_components.p, {
      children: "¥Publishing"
    }), "\n", _jsx(_components.p, {
      children: "软件包打包后，你可以将其发布到 npm 仓库。"
    }), "\n", _jsx(_components.p, {
      children: "¥Once your package has been bundled, you can then publish it to the npm registry."
    }), "\n", _jsx(_components.p, {
      children: "我们建议你查看变更集文档。以下是我们推荐的阅读顺序："
    }), "\n", _jsx(_components.p, {
      children: "¥We recommend taking a look at the Changesets docs. Here's our recommended reading order:"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.a, {
            href: "https://github.com/changesets/changesets/blob/main/docs/intro-to-using-changesets.md",
            children: "为什么使用变更集？"
          }), " - 一个介绍基础知识的简介。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "https://github.com/changesets/changesets/blob/main/docs/intro-to-using-changesets.md",
            children: "Why use changesets?"
          }), " - an intro that takes you through the fundamentals."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: _jsx(_components.a, {
            href: "https://github.com/changesets/changesets/blob/main/packages/cli/README.md",
            children: "安装说明"
          })
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.a, {
            href: "https://github.com/changesets/changesets/blob/main/packages/cli/README.md",
            children: "Installation instructions"
          })]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["如果你使用的是 GitHub，请考虑使用 ", _jsx(_components.a, {
            href: "https://github.com/apps/changeset-bot",
            children: "变更集 GitHub 机器人"
          }), " - 一个机器人，它会提醒你将变更集添加到 PR。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥If you're using GitHub, consider using the ", _jsx(_components.a, {
            href: "https://github.com/apps/changeset-bot",
            children: "Changeset GitHub bot"
          }), " - a bot to nudge you to add changesets to PR's."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["你还应该考虑添加 ", _jsx(_components.a, {
            href: "https://github.com/changesets/action",
            children: "变更集 GitHub 操作"
          }), "。 - 一个使发布变得极其简单的工具。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥You should also consider adding the ", _jsx(_components.a, {
            href: "https://github.com/changesets/action",
            children: "Changesets GitHub action"
          }), " - a tool which makes publishing extremely easy."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "将变更集与-turborepo-结合使用-using-changesets-with-turborepo",
      children: "将变更集与 Turborepo 结合使用 "
    }), "\n", _jsx(_components.p, {
      children: "¥Using Changesets with Turborepo"
    }), "\n", _jsx(_components.p, {
      children: "开始使用变更集后，你将可以使用三个有用的命令："
    }), "\n", _jsx(_components.p, {
      children: "¥Once you've started using Changesets, you'll gain access to three useful commands:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Add a new changeset"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "changeset"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Create new versions of packages"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "changeset"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " version"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Publish all changed packages to npm"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "changeset"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " publish"
            })]
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "将你的发布流程链接到 Turborepo 可以使你的部署组织更加简单快捷。"
    }), "\n", _jsx(_components.p, {
      children: "¥Linking your publishing flow into Turborepo can make organizing your deploy a lot simpler and faster."
    }), "\n", _jsxs(_components.p, {
      children: ["我们建议将变更集配置为自动提交 ", _jsx(_components.code, {
        children: "changeset version"
      }), " 的变更。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Our recommendation is to configure Changesets to automatically commit ", _jsx(_components.code, {
        children: "changeset version"
      }), "'s changes"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./.changeset/config.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "  // …"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"commit\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "  // …"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["并将 ", _jsx(_components.code, {
        children: "publish-packages"
      }), " 脚本添加到你的根 ", _jsx(_components.code, {
        children: "package.json"
      }), " 中："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥and add a ", _jsx(_components.code, {
        children: "publish-packages"
      }), " script into your root ", _jsx(_components.code, {
        children: "package.json"
      }), ":"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "    // Include build, lint, test - all the things you need to run"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "    // before publishing"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"publish-packages\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"turbo run build lint test && changeset version && changeset publish\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["如果你的包是公共的，请将变更集的 ", _jsx(_components.code, {
        children: "access"
      }), " 设置为 ", _jsx(_components.code, {
        children: "public"
      }), "："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If your packages are public, set Changeset's ", _jsx(_components.code, {
        children: "access"
      }), " to ", _jsx(_components.code, {
        children: "public"
      }), ":"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./.changeset/config.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "  // …"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"access\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"public\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "  // …"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(Callout, {
      children: [_jsxs(_components.p, {
        children: ["我们推荐使用 ", _jsx(_components.code, {
          children: "publish-packages"
        }), "，这样它就不会与 npm 内置的 ", _jsx(_components.code, {
          children: "publish"
        }), " 脚本冲突。"]
      }), _jsxs(_components.p, {
        children: ["¥We recommend ", _jsx(_components.code, {
          children: "publish-packages"
        }), " so that it doesn't conflict with npm's\nbuilt-in ", _jsx(_components.code, {
          children: "publish"
        }), " script."]
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["这意味着当你运行 ", _jsx(_components.code, {
        children: "publish-packages"
      }), " 时，你的 monorepo 会被构建、linted、测试和发布。 - 你将受益于 Turborepo 的所有加速功能。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This means that when you run ", _jsx(_components.code, {
        children: "publish-packages"
      }), ", your monorepo gets built, linted, tested and published - and you benefit from all of Turborepo's speedups."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
